import { useAppSelector } from "../../../../app/hooks";
import { DistrictCreateEditModel } from "../../districtsApiSlice";
import DistrictReportsSetting from "../settings/DistrictReportsSetting";
import DistrictUserAvatarSetting from "../settings/DistrictUserAvatarSetting";

interface DistrictSettingsProps {
	districtInfo: DistrictCreateEditModel;
	setErrorMessage: (message: string) => void;
}

export default function DistrictSettingsSection({
	districtInfo,
	setErrorMessage,
}: DistrictSettingsProps) {
	const { config } = useAppSelector((state) => state.site);

	return (
		<section className="grid grid-cols-2 xl:grid-cols-4 space-y-3 mt-4 items-start">
			{!config?.isUtahComposeSite && (
				<DistrictUserAvatarSetting
					districtInfo={districtInfo}
					setErrorMessage={setErrorMessage}
				/>
			)}
			<DistrictReportsSetting districtInfo={districtInfo} setErrorMessage={setErrorMessage} />
		</section>
	);
}
